import React from 'react'
import { Row, Col } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { BanerContainer, ContentItem, Grid } from './BanerStyledComponents'

const Baner = React.memo(
  ({ fixedWidth = false, bannerImage = '', children }) => (
    <BanerContainer fluid={!fixedWidth}>
      <Row>
        <Col
          xs={fixedWidth && { size: '12' }}
          sm={fixedWidth && { size: 10, offset: 1 }}
          lg={fixedWidth && { size: 10, offset: 1 }}
          xl={fixedWidth && { size: 8, offset: 2 }}
        >
          <Grid backgroundImage={bannerImage}>
            <ContentItem>{children}</ContentItem>
          </Grid>
        </Col>
      </Row>
    </BanerContainer>
  )
)

Baner.displayName = 'Banner'

Baner.propTypes = {
  bannerImage: PropTypes.string,
  fixedWidth: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

export default withRouter(Baner)
export { Baner }
